/* =========================================================
   HORTIGO DEVIZIER — assets/hg-devizier.js (V94)
   - Local, controlabil prin config JSON (assets/devizier-config.json)
   - Output HTML-only (fără markdown)
   - Produse legate prin productIndex (productId -> url + variantId)
   - ✅ Add-to-cart per produs + ✅ Add ALL recommended to cart
========================================================= */

(() => {
  "use strict";

  const ROOT = document.getElementById("hg-root");
  if (!ROOT) return;

  const cfgUrl = ROOT.getAttribute("data-dz-config-url");
  if (!cfgUrl) return;

  const UI = {
    cats: document.getElementById("dzCats"),
    crops: document.getElementById("dzCrops"),
    cropHelp: document.getElementById("dzCropHelp"),

    levelBtns: Array.from(document.querySelectorAll("#hg-root #hg-iso .dz-level")),
    wizTabs: Array.from(document.querySelectorAll("#hg-root #hg-iso .dz-wizTab")),
    steps: Array.from(document.querySelectorAll("#hg-root #hg-iso .dz-step")),

    budgetWrap: document.getElementById("dzBudget"),
    budgetBtns: Array.from(document.querySelectorAll("#hg-root #hg-iso #dzBudget .dz-chip")),

    system: document.getElementById("dzSystem"),
    area: document.getElementById("dzArea"),
    unit: document.getElementById("dzUnit"),
    irrigation: document.getElementById("dzIrrigation"),
    soil: document.getElementById("dzSoil"),
    startMonth: document.getElementById("dzStartMonth"),
    pref: document.getElementById("dzPref"),

    run: document.getElementById("dzRun"),
    out: document.getElementById("out-s"),

    load: document.getElementById("dzLoad"),
    progbar: document.getElementById("dzProgbar"),
    progText: document.getElementById("dzProgText"),
    retry: document.getElementById("dzRetry")
  };

  // IMPORTANT: trebuie să corespundă cu config.levels
  const LEVELS = ["starter", "mediu", "profesionist"]; // ordonare
  const levelIdx = (l) => Math.max(0, LEVELS.indexOf(l));

  const S = {
    cfg: null,
    level: "starter",
    catId: null,
    cropId: null,
    budget: "redus",
    step: 1
  };

  const escapeHTML = (s) => String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

  function setStep(step) {
    S.step = step;
    for (const btn of UI.wizTabs) {
      const n = Number(btn.getAttribute("data-step"));
      btn.classList.toggle("is-active", n === step);
    }
    for (const pane of UI.steps) {
      const n = Number(pane.getAttribute("data-step"));
      pane.classList.toggle("is-active", n === step);
    }
  }

  function unlockStep(step) {
    const btn = UI.wizTabs.find((b) => Number(b.getAttribute("data-step")) === step);
    if (!btn) return;
    btn.classList.remove("is-locked");
    btn.disabled = false;
  }

  function lockStep(step) {
    const btn = UI.wizTabs.find((b) => Number(b.getAttribute("data-step")) === step);
    if (!btn) return;
    btn.classList.add("is-locked");
    btn.disabled = true;
  }

  function renderCats() {
    if (!UI.cats || !S.cfg) return;

    UI.cats.innerHTML = (S.cfg.categories || []).map((c) => {
      const active = S.catId === c.id ? "is-active" : "";
      return `
        <button class="dz-tile ${active}" type="button" data-cat="${escapeHTML(c.id)}">
          <div class="dz-ico">${escapeHTML(c.icon || "📦")}</div>
          <div>
            <div class="dz-t">${escapeHTML(c.name)}</div>
            <div class="dz-d">${escapeHTML(c.desc || "")}</div>
          </div>
        </button>
      `;
    }).join("");

    UI.cats.querySelectorAll(".dz-tile").forEach((btn) => {
      btn.addEventListener("click", () => {
        S.catId = btn.getAttribute("data-cat");
        S.cropId = null;
        renderCats();
        renderCrops();
        unlockStep(2);
        lockStep(3);
        lockStep(4);
        setStep(2);
        validate();
      });
    });
  }

  function getCat() {
    return (S.cfg.categories || []).find((c) => c.id === S.catId) || null;
  }

  function getCrop() {
    const cat = getCat();
    return (cat?.crops || []).find((x) => x.id === S.cropId) || null;
  }

  function renderCrops() {
    if (!UI.crops || !S.cfg) return;
    const cat = getCat();
    const crops = cat?.crops || [];

    UI.crops.innerHTML = crops.map((cr) => {
      const active = S.cropId === cr.id ? "is-active" : "";
      const tags = (cr.tags || []).map((t) => `<span class="dz-tag">${escapeHTML(t)}</span>`).join("");
      return `
        <button class="dz-tile ${active}" type="button" data-crop="${escapeHTML(cr.id)}">
          <div class="dz-ico">${escapeHTML(cr.icon || "🌱")}</div>
          <div>
            <div class="dz-t">${escapeHTML(cr.name)}</div>
            <div class="dz-d">${escapeHTML(cr.summary || "")}</div>
            ${tags ? `<div class="dz-tags">${tags}</div>` : ""}
          </div>
        </button>
      `;
    }).join("");

    if (UI.cropHelp) UI.cropHelp.textContent = "";

    UI.crops.querySelectorAll(".dz-tile").forEach((btn) => {
      btn.addEventListener("click", () => {
        S.cropId = btn.getAttribute("data-crop");
        renderCrops();
        unlockStep(3);
        lockStep(4);
        setStep(3);

        const crop = getCrop();
        if (UI.cropHelp && crop?.summary) UI.cropHelp.textContent = crop.summary;

        validate();
      });
    });
  }

  function bindLevels() {
    for (const btn of UI.levelBtns) {
      btn.addEventListener("click", () => {
        UI.levelBtns.forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        S.level = btn.getAttribute("data-level") || "starter";
        validate();
      });
    }
  }

  function bindWizardTabs() {
    for (const btn of UI.wizTabs) {
      btn.addEventListener("click", () => {
        if (btn.disabled) return;
        const step = Number(btn.getAttribute("data-step"));
        setStep(step);
      });
    }
  }

  function bindBudget() {
    for (const btn of UI.budgetBtns) {
      btn.addEventListener("click", () => {
        UI.budgetBtns.forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        S.budget = btn.getAttribute("data-budget") || "redus";
        unlockStep(4);
        setStep(4);
        validate();
      });
    }
  }

  function areaToMp(val, unit) {
    const v = Number(val);
    if (!Number.isFinite(v) || v <= 0) return 0;
    if (unit === "ha") return v * 10000;
    return v;
  }

  function validate() {
    const crop = getCrop();
    const areaMp = areaToMp(UI.area?.value, UI.unit?.value);

    const ok = Boolean(
      S.level &&
      S.catId &&
      crop &&
      S.budget &&
      UI.system?.value &&
      areaMp > 0
    );

    if (UI.run) UI.run.disabled = !ok;
    return ok;
  }

  function stageAllowed(stageMinLevel, chosenLevel) {
    return levelIdx(chosenLevel) >= levelIdx(stageMinLevel || "starter");
  }

  function monthName(m) {
    const map = {
      1:"Ianuarie",2:"Februarie",3:"Martie",4:"Aprilie",5:"Mai",6:"Iunie",
      7:"Iulie",8:"August",9:"Septembrie",10:"Octombrie",11:"Noiembrie",12:"Decembrie"
    };
    return map[Number(m)] || "";
  }

  function productCardHTML(pid) {
    const p = (S.cfg.productIndex || {})[pid] || null;
    if (!p) {
      return `
        <div class="hg-admin-item">
          <div><strong>Produs (ID: ${escapeHTML(pid)})</strong><div class="hg-muted">Nu există în productIndex.</div></div>
        </div>
      `;
    }

    const title = escapeHTML(p.title || `Produs ${pid}`);
    const url = escapeHTML(p.url || "#");
    const variantId = Number(p.variantId || 0);

    return `
      <div class="hg-admin-item" style="border-style:solid; border-color: var(--hg-line);">
        <div>
          <strong>${title}</strong>
          <div class="hg-muted">Product ID: ${escapeHTML(pid)}</div>
          <div style="display:flex; gap:8px; flex-wrap:wrap; margin-top:10px;">
            <a class="hg-tier" href="${url}" style="text-decoration:none; display:inline-flex; align-items:center;" target="_blank" rel="noopener">Vezi produs</a>
            ${variantId > 0 ? `<button class="hg-tier dz-add" type="button" data-vid="${variantId}">Adaugă în coș</button>` : ``}
          </div>
        </div>
      </div>
    `;
  }

  async function addToCart(variantId, qty = 1) {
    try {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(qty || 1) })
      });
      if (!r.ok) throw new Error("add failed");
      return true;
    } catch (e) {
      return false;
    }
  }

  async function addManyToCart(variantIds) {
    // Shopify acceptă /cart/add.js per item; alternativ există /cart/add.js cu items[] (depinde),
    // mergem safe: sequential, ca să vezi exact unde crapă.
    let okCount = 0;
    for (const vid of variantIds) {
      const ok = await addToCart(vid, 1);
      if (ok) okCount++;
    }
    return { okCount, total: variantIds.length };
  }

  function bindAddButtons(scopeEl) {
    if (!scopeEl) return;
    scopeEl.querySelectorAll(".dz-add").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const vid = Number(btn.getAttribute("data-vid"));
        if (!vid) return;
        btn.disabled = true;
        const ok = await addToCart(vid, 1);
        btn.disabled = false;
        btn.textContent = ok ? "Adăugat ✓" : "Eroare";
        setTimeout(() => { btn.textContent = "Adaugă în coș"; }, 1600);
      });
    });

    // Add all
    const addAllBtn = scopeEl.querySelector("[data-dz-addall]");
    if (addAllBtn) {
      addAllBtn.addEventListener("click", async () => {
        const vidsRaw = (addAllBtn.getAttribute("data-dz-vids") || "").trim();
        const vids = vidsRaw
          .split(",")
          .map((x) => Number(x.trim()))
          .filter((n) => Number.isFinite(n) && n > 0);

        if (!vids.length) {
          addAllBtn.textContent = "Nimic de adăugat";
          setTimeout(() => { addAllBtn.textContent = "Adaugă toate în coș"; }, 1400);
          return;
        }

        addAllBtn.disabled = true;
        const old = addAllBtn.textContent;
        addAllBtn.textContent = "Se adaugă…";

        const r = await addManyToCart(vids);

        addAllBtn.disabled = false;
        addAllBtn.textContent =
          r.okCount === r.total ? `Adăugat (${r.okCount}) ✓` : `Parțial: ${r.okCount}/${r.total}`;

        setTimeout(() => { addAllBtn.textContent = old; }, 1900);
      });
    }
  }

  function collectVariantIdsForCurrentSelection() {
    const cat = getCat();
    const crop = getCrop();
    if (!cat || !crop) return [];

    const sys = UI.system?.value || "camp";
    const budget = S.budget;

    const stageIds = (crop.stages || []);
    const variants = [];

    for (const stId of stageIds) {
      // stId este string in crop.stages, dar stages sunt din stageLibrary
      const pidPack = crop?.products?.[stId]?.[sys]?.[budget] || null;
      const main = pidPack?.main || null;
      const alts = Array.isArray(pidPack?.alts) ? pidPack.alts : [];

      const pids = [main, ...alts].filter(Boolean);

      for (const pid of pids) {
        const p = (S.cfg.productIndex || {})[pid];
        const vid = Number(p?.variantId || 0);
        if (vid > 0) variants.push(vid);
      }
    }

    // dedupe
    return Array.from(new Set(variants));
  }

  function buildDevizHTML() {
    const cat = getCat();
    const crop = getCrop();
    const areaMp = areaToMp(UI.area?.value, UI.unit?.value);

    const sys = UI.system?.value || "camp";
    const irr = UI.irrigation?.value || "nu";
    const soil = UI.soil?.value || "lutos";
    const sm = UI.startMonth?.value || "";
    const pref = UI.pref?.value || "echilibrat";

    // stage objects from library
    const stageLib = Array.isArray(S.cfg.stageLibrary) ? S.cfg.stageLibrary : [];
    const wantedIds = Array.isArray(crop?.stages) ? crop.stages : [];
    const stages = wantedIds
      .map((id) => stageLib.find((x) => x.id === id))
      .filter(Boolean)
      .filter((st) => stageAllowed(st.minLevel, S.level));

    const vids = collectVariantIdsForCurrentSelection();
    const addAllBtnHtml = `
      <button
        class="hg-btn hg-btn-ghost"
        type="button"
        data-dz-addall="1"
        data-dz-vids="${escapeHTML(vids.join(","))}"
        style="width:auto; margin-top:10px;"
      >Adaugă toate în coș</button>
    `;

    const summary = `
      <div class="hg-card" style="border:none; box-shadow:none;">
        <div style="padding: 14px; border:1px solid var(--hg-line); border-radius: 16px; background: rgba(31,122,59,.04);">
          <div style="font-weight:950; font-size:16px;">Rezumat deviz</div>
          <div style="margin-top:8px; line-height:1.45;">
            <div><strong>Nivel:</strong> ${escapeHTML(S.level)}</div>
            <div><strong>Buget:</strong> ${escapeHTML(S.budget)}</div>
            <div><strong>Categorie:</strong> ${escapeHTML(cat?.name || "-")}</div>
            <div><strong>Cultură:</strong> ${escapeHTML(crop?.name || "-")}</div>
            <div><strong>Sistem:</strong> ${escapeHTML(sys)}</div>
            <div><strong>Suprafață:</strong> ${escapeHTML(UI.area?.value || "0")} ${escapeHTML(UI.unit?.value || "mp")} (${Math.round(areaMp)} mp)</div>
            <div><strong>Irigare:</strong> ${escapeHTML(irr)}</div>
            <div><strong>Sol/Substrat:</strong> ${escapeHTML(soil)}</div>
            <div><strong>Start:</strong> ${escapeHTML(monthName(sm) || "-")}</div>
            <div><strong>Preferință:</strong> ${escapeHTML(pref)}</div>
          </div>

          ${vids.length ? `<div style="margin-top:10px; display:flex; gap:10px; flex-wrap:wrap; align-items:center;">${addAllBtnHtml}<span class="hg-muted">(${vids.length} produse cu “Adaugă în coș”)</span></div>` : `<div class="hg-muted" style="margin-top:10px;">Nu există produse mapate cu variantId pentru coș.</div>`}

          <div class="hg-muted" style="margin-top:10px;">Notă: cantitățile sunt orientative; mapping-ul de produse este controlat din config.</div>
        </div>
      </div>
    `;

    const stageHtml = stages.map((st, idx) => {
      const pidPack = crop?.products?.[st.id]?.[sys]?.[S.budget] || null;
      const main = pidPack?.main || null;
      const alts = Array.isArray(pidPack?.alts) ? pidPack.alts : [];

      const mainHtml = main ? productCardHTML(main) : `<div class="hg-empty">Nu există produs principal mapat pentru etapa aceasta.</div>`;
      const altsHtml = alts.length
        ? `<div style="margin-top:10px;">
            <div style="font-weight:950; margin: 4px 0 8px;">Alternative</div>
            ${alts.map(productCardHTML).join("")}
          </div>`
        : "";

      const what = `
        <div style="margin-top:10px;">
          <div style="font-weight:950; margin-bottom:6px;">Ce faci</div>
          <ul style="margin:0; padding-left:18px; line-height:1.45;">
            <li>Urmezi pașii specifici culturii pentru etapa „${escapeHTML(st.name)}”.</li>
            <li>Adaptezi dozele/cantitățile la suprafață și condiții (sol, irigare, sistem).</li>
          </ul>
        </div>
      `;

      const why = `
        <div style="margin-top:10px;">
          <div style="font-weight:950; margin-bottom:6px;">Atenții</div>
          <ul style="margin:0; padding-left:18px; line-height:1.45;">
            <li>Respectă eticheta produselor și recomandările locale (climă / zonă).</li>
            <li>Dacă preferința este „bio”, evită tratamentele cu perioadă lungă de pauză.</li>
          </ul>
        </div>
      `;

      return `
        <details style="border:1px solid var(--hg-line); border-radius:16px; background:#fff; margin-top:10px; overflow:hidden;">
          <summary style="padding:12px 14px; cursor:pointer; font-weight:950; display:flex; justify-content:space-between; gap:12px;">
            <span>${escapeHTML(idx + 1)}. ${escapeHTML(st.name)}</span>
            <span class="hg-muted" style="font-weight:900;">deschide</span>
          </summary>
          <div style="padding:14px; border-top:1px solid var(--hg-line);">
            ${what}
            ${why}
            <div style="margin-top:12px; font-weight:950;">Produse recomandate</div>
            <div style="margin-top:8px;">${mainHtml}</div>
            ${altsHtml}
            <div class="hg-muted" style="margin-top:10px;">Cantități orientative: vor fi calculate când adăugăm coeficienți per etapă (config).</div>
          </div>
        </details>
      `;
    }).join("");

    return `
      <div>
        ${summary}
        <div style="margin-top:12px;">
          <div style="font-weight:950; font-size:16px;">Etape</div>
          ${stageHtml || `<div class="hg-empty">Nu există etape definite pentru selecția curentă.</div>`}
        </div>
      </div>
    `;
  }

  function setLoading(on) {
    if (!UI.load) return;
    UI.load.classList.toggle("hidden", !on);
  }

  async function simulate() {
    if (!validate()) return;

    setLoading(true);
    if (UI.run) UI.run.disabled = true;

    const steps = [
      { pct: 18, txt: "Structurare…" },
      { pct: 46, txt: "Produse…" },
      { pct: 72, txt: "Calendar…" },
      { pct: 100, txt: "Finalizare…" }
    ];

    const tick = async () => {
      for (const s of steps) {
        if (UI.progbar) UI.progbar.style.width = `${s.pct}%`;
        if (UI.progText) UI.progText.textContent = s.txt;
        await new Promise((r) => setTimeout(r, 220));
      }
    };

    await tick();

    const html = buildDevizHTML();
    if (UI.out) {
      UI.out.innerHTML = html;
      bindAddButtons(UI.out);
    }

    setLoading(false);
    if (UI.run) UI.run.disabled = false;
  }

  function bindDetailsValidation() {
    [UI.system, UI.area, UI.unit, UI.irrigation, UI.soil, UI.startMonth, UI.pref].forEach((el) => {
      if (!el) return;
      el.addEventListener("change", validate);
      el.addEventListener("input", validate);
    });
  }

  async function boot() {
    try {
      const r = await fetch(cfgUrl, { cache: "no-store" });
      const d = await r.json();
      S.cfg = d;
    } catch (e) {
      if (UI.out) UI.out.innerHTML = `<div class="hg-empty">Nu pot încărca devizier-config.json.</div>`;
      return;
    }

    // init
    bindLevels();
    bindWizardTabs();
    bindBudget();
    bindDetailsValidation();

    // lock chain: 2/3/4
    unlockStep(1);
    lockStep(2);
    lockStep(3);
    lockStep(4);
    setStep(1);

    renderCats();
    renderCrops();

    if (UI.run) UI.run.addEventListener("click", simulate);
    if (UI.retry) UI.retry.addEventListener("click", simulate);

    validate();
  }

  boot();
})();
